export default "__VITE_ASSET__CqjuB7U9__"